import { api } from '@/core/api/'
const URL = 'api/rp'

export default {
  getRequestServiceStatuses() {
    return api.get(`${URL}/requestservicestatuses`)
  },
  getServiceStatuses() {
    return api.get(`${URL}/servicestatuses`)
  },
  getRequestServiceTypes() {
    return api.get(`${URL}/requestservicetypes`)
  },
  getContractStatuses() {
    return api.get(`${URL}/contractstatuses`)
  },
  getProviders(academicYearId) {
    return api.get(`${URL}/providers/${academicYearId}`)
  },
  getProvidersWithVisits(academicYearId, semester, month = null) {
    return api.get(`${URL}/providerswithvisit/${academicYearId}/${semester}`, {
      params: {
        month,
      },
    })
  },
  getSpecialists(academicYearId, companyId = null) {
    return api.get(`${URL}/specialists/${academicYearId}`, {
      params: {
        companyId,
      },
    })
  },
  getCompanyTypes() {
    return api.get(`${URL}/companytypes`)
  },
  getBillingStatusIndicator(academicYearId, companyTypeId = null) {
    return api.get(`${URL}/billing-status-indicator/${academicYearId}`, {
      params: { companyTypeId },
    })
  },
}
